import Reports from "@/components/sidebar-components/Reports";
import { DateFilterKey } from "@/utils/dateFilters";
import { UserOrganizationRole } from "@blinkbooks/types";

interface ReportsAnalyticsProps {
  dateFilterKey: DateFilterKey | "";
  dateCustomFrom?: Date;
  dateCustomTo?: Date;
  onDateFilterChange: (key: DateFilterKey | "", from?: Date, to?: Date) => void;
  role?: UserOrganizationRole | null;
}

const ReportsAnalytics = ({ dateFilterKey, dateCustomFrom, dateCustomTo, onDateFilterChange, role }: ReportsAnalyticsProps) => {
  return (
    <Reports
      dateFilterKey={dateFilterKey}
      dateCustomFrom={dateCustomFrom}
      dateCustomTo={dateCustomTo}
      onDateFilterChange={onDateFilterChange}
      role={role}
    />
  );
};

export default ReportsAnalytics;
